import {
  GetGiftingPageAndAccountByIdResDto,
  GetVssPlanByIdResDto
} from '@portal-middleware/hooks';
import { SessionDto } from '@sentinel/hooks';
import { UseQueryResult } from '@tanstack/react-query';
import { WizardProviderCtx } from '@vestwell-frontend/ui';

import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useContext
} from 'react';

import { CreateGiftState } from '../config';
import { useGiftState } from '../hooks/useGiftState';

interface GiftStateContextProps {
  clearSessionIfNotLoggedIn: () => void;
  ctx: WizardProviderCtx<CreateGiftState>;
  user: UseQueryResult<SessionDto>;
  plan: UseQueryResult<GetVssPlanByIdResDto>;
  giftAndAccount: UseQueryResult<GetGiftingPageAndAccountByIdResDto>;
  giftContributorId: string | null;
  setGiftContributorId: Dispatch<SetStateAction<string | null>>;
}

const GiftStateContext = createContext<GiftStateContextProps | undefined>(
  undefined
);

export const GiftStateProvider: FC<{
  isPublicPage: boolean;
  children: ReactNode;
}> = ({ isPublicPage, children }) => {
  const giftState = useGiftState(isPublicPage);

  return (
    <GiftStateContext.Provider value={giftState}>
      {children}
    </GiftStateContext.Provider>
  );
};

export const useGiftStateContext = () => {
  const context = useContext(GiftStateContext);
  if (context === undefined) {
    throw new Error(
      'useGiftStateContext must be used within a GiftStateProvider'
    );
  }
  return context;
};
